module.exports = __webpack_public_path__ + "img/step-3.ac23d460.png";